// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2VSCd","image":"Header_image__3mOXs","name":"Header_name__kybo6","info":"Header_info__3lXZp","infoRow":"Header_infoRow__2pAzC"};